/**
 * Service worker registration — production only.
 *
 * Enabling the PWA plugin's dev service worker breaks Vite (modules get index.html
 * instead of JS), which shows up as a blank screen. Stale workers from earlier dev
 * sessions can do the same until they are cleared.
 */

export async function setupPwa(): Promise<void> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return

  const { registerSW } = await import('virtual:pwa-register')
  registerSW({ immediate: true })
}

/** Drop any service workers while developing so an old PWA build cannot hijack localhost. */
export async function clearDevServiceWorkers(): Promise<void> {
  if (!import.meta.env.DEV || !('serviceWorker' in navigator)) return
  const registrations = await navigator.serviceWorker.getRegistrations()
  await Promise.all(registrations.map((r) => r.unregister()))
  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(keys.map((k) => caches.delete(k)))
  }
}
